import React, { Component } from 'react';
import { Utils } from '../../utils/Utils';
import CountdownTimer from './CountdownTimer';
import { ReplayAction } from './ReplayActionBuilder';

window.actionID;
window.circleItem;

/**
 * cid=1_1_1&page=3
 * cid=2_1_1&page=8 一页存在多次圈图动画
 */

// let rangeSize = 50; //感应范围容错大小，越大越容易拖进框内

class DrawCircle extends Component {

    constructor(props) {
        super(props);
        const width = props.item.detail.srcObjs[0].size.width / 2;
        const height = props.item.detail.srcObjs[0].size.height / 2;
        this.state = {
            left: 0, //实时显示位置
            top: 0,     //实时显示位置0
            display: 'none',
            selected: false,
            timeout: false,
            startCircle: false,
            mainSize: { //显示区的宽高
                width: 690,
                height: 518
            },
            circle: {
                width: Math.min(width, height) * window.mainSize.percent + 20,
                height: Math.min(width, height) * window.mainSize.percent + 20,
                // width: Math.min(width, height) + Math.abs(width - height) / 2,
                // height: Math.min(width, height) + Math.abs(width - height) / 2, //props.item.detail.srcObjs[0].size.height / 2 || 160,
            },
            currStarCount: 0,   //当前的星星数
            currSubjectCount: 0,    //当前题目数（有starSubject=1的时候就加1）
        };
        this.replayKeyNum = 2;  //录屏的key，默认有一个 begin和feedback，因此默认是2，每次调用一下ReplayAction.add，就加1
        this.cid = Utils.getHashQueryString("cid");
        this.putaoid = Utils.getCookie('putaoid') || 0;
        this.token = Utils.getCookie('token');
        this.uuid = Utils.getCookie('uuid') || 0;
        this.roundNum = 1;  // 第几轮
        this.retryTimes = -1;
        this.startWorkTime = new Date().getTime();  // 开始时间，用来计算完成这个模板使用的时间，用于算给积分
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.currStarCount !== this.state.currStarCount || nextProps.currSubjectCount !== this.state.currSubjectCount) {
            this.setState({
                currStarCount: nextProps.currStarCount,
                currSubjectCount: nextProps.currSubjectCount,
                // startCircle: this.state.startCircle
            })
        }
    }

    componentDidMount() {
        let content_size = {};
        let content_course = document.getElementById('content_course');
        content_size.width = content_course.clientWidth;
        content_size.height = content_course.clientHeight;
        window.circleItem = this.props.item;
        this.retryTimes = window.circleItem.retryTimes;
        this.setState({
            mainSize: content_size,
            startCircle: true,
        }, () => {
            //录屏相关代码
            if (window.needRecoRecordCourse) {
                if (!(window.g_currentScene && window.g_currentScene.timeline)) {
                    ReplayAction.setScene(JSON.stringify(window.curPageSceneList));
                }
                ReplayAction.add(window.keyStr, 'CIRCLE_REPLAY_BEGIN', (new Date().getTime() - window.recordPageTime), JSON.stringify({}));
            }
        });
        this.startWorkTime = new Date().getTime();
    }

    mouseMove(e) {
        const { circle } = this.state;
        const content_course = document.getElementById('content_course');
        const start_top = Utils.getElementOffsetTop(content_course);
        const start_left = Utils.getElementOffsetLeft(content_course);
        this.setState({
            top: e.pageY - start_top - circle.height / 2,
            left: e.pageX - start_left - circle.width / 2,
            display: 'block'
        });
    }

    mouseClick(e) {
        if (document.getElementById("content").className === "content toCenter") {
            const that = this;
            const { changeSelect } = this.props;
            const { circle, mainSize } = this.state;
            const item = window.circleItem || that.props.item;
            const content_course = document.getElementById('content_course');
            const start_top = Utils.getElementOffsetTop(content_course);
            const start_left = Utils.getElementOffsetLeft(content_course);
            const ev = e.targetTouches ? e.targetTouches[0] || e.changedTouches[0] : e;

            //点击的位置
            let _top = ev.pageY - start_top;
            let _left = ev.pageX - start_left;

            //录屏相关代码
            if (window.needRecoRecordCourse) {
                if (!(window.g_currentScene && window.g_currentScene.timeline)) {
                    ReplayAction.setScene(JSON.stringify(window.curPageSceneList));
                }
                let linepoints = [];
                let times = 0;
                for (let i = 0; i < 20; i++) {
                    times += 3;
                    let hudu = (2 * Math.PI / 360) * 6 * times;
                    let X = _left + Math.sin(hudu) * circle.width / 2;
                    let Y = _top - Math.cos(hudu) * circle.height / 2;    //注意此处是“-”号，因为我们要得到的Y是相对于（0,0）而言的。
                    linepoints.push({ "x": X / mainSize.width, "y": Y / mainSize.height });
                }
                let detail = {
                    "linepoints": linepoints
                }
                ReplayAction.add(window.keyStr, 'CIRCLE_REPLAY_DRAWLINE', (new Date().getTime() - window.recordPageTime), JSON.stringify(detail));
                that.replayKeyNum++;
            }

            //正确位置，srcObjs 里面会放成功和失败的情况，失败是为了通过失败图片来区分出不一样的视频
            let isClickImg = false; //记录圈图动作是否选中了图片
            for (let i = 0; i < item.detail.srcObjs.length; i++) {
                let right_top = item.detail.srcObjs[i].pos.y * mainSize.height;
                let right_left = item.detail.srcObjs[i].pos.x * mainSize.width;

                if (_top > right_top &&
                    _top < right_top + item.detail.srcObjs[i].size.height / 2 &&
                    _left > right_left &&
                    _left < right_left + item.detail.srcObjs[i].size.width / 2
                ) {  //计算范围
                    that.handleSelect(item.detail.srcObjs[i]);
                    isClickImg = true;
                    break;
                }
            }

            that.setState({
                selected: true,
                startCircle: false,
            }, () => {
                if (!isClickImg) {
                    that.handleSelect(item.detail.feedbacks.nohit);
                }

                if (changeSelect && typeof changeSelect === 'function') {
                    changeSelect();
                }
            });
        }

    }

    //兼容触屏版
    touchMove(e) {
        const { circle } = this.state;
        const content_course = document.getElementById('content_course');
        const start_top = Utils.getElementOffsetTop(content_course);
        const start_left = Utils.getElementOffsetLeft(content_course);
        let touch = e.targetTouches[0] || e.changedTouches[0];
        this.setState({
            top: touch.pageY - start_top - circle.height / 2,
            left: touch.pageX - start_left - circle.width / 2,
            display: 'block'
        });
    }

    handleSelect(feedback) {
        const that = this;
        const { childCallback, isReview } = this.props;
        const { currStarCount, currSubjectCount } = this.state;
        const item = window.circleItem || that.props.item;
        const judgeFunction = item.detail.judgeFunction;
        const timeout = item.detail && item.detail.feedbacks && item.detail.feedbacks.timeout ? item.detail.feedbacks.timeout : null;
        let type = "";
        let info = "";
        if (!isReview && window.toCenter === 1) {
            if (feedback) {
                if (feedback.type) {
                    type = feedback.type;
                }
                if (feedback.info) {
                    info = feedback.info;
                }

                //圈图后，保留圆圈
                if (item.retryTimes === 0) {
                    let drawCircle = document.getElementById('drawCircle');
                    // cid=1_3_3&page=4 第二次circle会报错，注释掉
                    // let countdoenTimeout = document.getElementById('countdoenTimeout');
                    // if (countdoenTimeout) {
                    //     countdoenTimeout.parentNode.removeChild(countdoenTimeout);
                    // }
                    drawCircle && document.getElementById('content_course').appendChild(drawCircle);
                }
            } else {
                type = timeout ? timeout.type : "";
                info = timeout ? timeout.info : "";
                if (window.toCenter === 1) {
                    that.setState({
                        timeout: true
                    });
                }
            }
            if (judgeFunction) {
                let returnScore = JSON.parse(window[judgeFunction](
                    item.actionID,
                    item.detail.resourceID,
                    type,
                    info,
                    item.retryTimes,
                    currStarCount,
                    currSubjectCount,
                ));
                if (returnScore && returnScore.resultInfo && returnScore.timeline) {
                    if (childCallback && typeof childCallback === 'function') {
                        if (window.needRecoRecordCourse) {
                            ReplayAction.add(window.keyStr, 'CIRCLE_REPLAY_FEEDBACK', (new Date().getTime() - window.recordPageTime), JSON.stringify(returnScore));
                            ReplayAction.commit(window.keyStr, 'CircleGameInteraction_');
                            window.keyStr += `.detail.timeline.nodes[${that.replayKeyNum}].actions[0]`;

                            childCallback(returnScore, ReplayAction.getScene());

                            ReplayAction.cleanScene();
                        } else {
                            childCallback(returnScore);
                        }
                        window.toCenter = 0;
                        window.circleItem = null;
                    }
                }

                //上报学习报告
                if (that.cid) {
                    // Utils.reportRecord(window.startTime, item.actionID, item.actionType, type, 0, item.knowledge);
                    if (item.actionID === window.actionID) {
                        that.roundNum++;
                    } else {
                        that.roundNum = 1;
                    }
                    window.actionID = item.actionID;
                    Utils.newReportRecord({
                        "cid": that.cid,
                        "startTime": window.startTime,
                        "actionId": item.actionID,
                        "actionType": item.actionType,
                        "fbType": type,   //fbType,
                        "roundNum": that.roundNum,  //轮数（第几轮回答，默认第一轮：1）
                        "score": 0,
                        "pageNum": window.curPageToReport || 0,
                    }, {
                        "knowledge": item.knowledge
                    });

                    // 给积分
                    Utils.giveIntegrals(1, {
                        totalTime: timeout ? timeout.time : 60,
                        useTime: (new Date().getTime() - that.startWorkTime) / 1000,
                        roundNum: that.roundNum,
                        fbType: type
                    });

                    // 勋章上报
                    Utils.encourageRecord({
                        "cid": that.cid,
                        "startTime": window.startTime,
                        "actionId": item.actionID,
                        "actionType": item.actionType,
                        "fbType": type,   //fbType,
                        "roundNum": that.roundNum,  //轮数（第几轮回答，默认第一轮：1）
                        "score": 0,
                        "pageNum": window.curPageToReport || 0,
                        "integrals": window.curIntegrals,
                    });
                }
            }
        }
    }

    render() {
        const that = this;
        // const { item } = this.props;
        const { top, left, display, circle, selected, timeout, startCircle } = this.state;
        const item = window.circleItem || this.props.item;
        return (
            <div>
                {
                    !timeout ?
                        startCircle || (window.isRuningActionName === "CircleGameInteraction_" && window.toCenter === 1) ?
                            <div id="drawCircle" className="draw-circle"
                                onMouseMove={!selected || window.toCenter === 1 ? (e) => that.mouseMove(e) : null}
                                onMouseUp={(e) => that.mouseClick(e)}
                                onTouchMove={!selected || window.toCenter === 1 ? (e) => that.touchMove(e) : null}
                                onTouchEnd={(e) => that.mouseClick(e)}
                            >
                                {
                                    (!selected || window.toCenter === 1) && item.detail.feedbacks && item.detail.feedbacks.timeout && item.detail.feedbacks.timeout.time
                                        && (that.retryTimes === item.retryTimes)   // 修复第一次圈错，第二次圈图不操作，会触发两次倒计时回调报错   https://che.putaoabc.com:8443/?code=1#/on?v=7.0&url=https%3A%2F%2Fcres.putaoabc.com%2Flevel2%2Funit7%2Flesson1%2F1554776626%2Fcourses.txt&cid=2_7_1&page=7
                                        ?
                                        <CountdownTimer feedbacks={item.detail.feedbacks} complateCallback={that.handleSelect.bind(that)} />
                                        : null
                                }
                                <div className="circle-do" style={{
                                    "top": top,
                                    "left": left,
                                    "width": circle.width,
                                    "height": circle.height,
                                    "display": display,
                                    "borderRadius": circle.width
                                }} />
                            </div>
                            : <div id="drawCircle" className="draw-circle">
                                <div className="circle-do" style={{
                                    "top": top,
                                    "left": left,
                                    "width": circle.width,
                                    "height": circle.height,
                                    "display": display,
                                    "borderRadius": circle.width
                                }} />
                            </div>
                        : null
                }
            </div>
        );
    }
}

export default DrawCircle;



// WEBPACK FOOTER //
// ./src/components/on/DrawCircle.js